import { render, staticRenderFns } from "./Details_info.vue?vue&type=template&id=4b7385f7&scoped=true"
import script from "./Details_info.vue?vue&type=script&lang=js"
export * from "./Details_info.vue?vue&type=script&lang=js"
import style0 from "./Details_info.vue?vue&type=style&index=0&id=4b7385f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7385f7",
  null
  
)

export default component.exports